import { usePlatformStats } from './usePlatformStats'
import { selectPlatformStatCells, type PlatformStatCell } from './platformStatCells'

/**
 * The four platform-counter tiles shared by the home proof strip, About, and
 * Solutions (docs/ux/2026-09-23-platform-counters.md). One hook, one fetch —
 * `usePlatformStats` is itself the single source of truth for
 * `GET /stats/public` — so the three surfaces can never disagree.
 */
export function usePlatformStatCells(): PlatformStatCell[] {
  const stats = usePlatformStats()
  return selectPlatformStatCells(stats.status, stats.data)
}

export type { PlatformStatCell } from './platformStatCells'
export { PLATFORM_STAT_FACTS, PLATFORM_STAT_LABELS } from './platformStatCells'
